export default __webpack_public_path__ + "static/media/ellipse.a14d7186.svg";